import {inject, Injectable} from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { UtilityService } from "@irb-common/services/utility.service";

@Injectable({
  providedIn: "root",
})
export class DevelopmentGuard  {
  constructor(private util: UtilityService) {}

  canActivate() {
    return this.util.getEnv() !== "PROD";
  }
}

export const developmentGuard: CanActivateFn = () => inject(DevelopmentGuard).canActivate();